export default "<svg viewBox=\"0 0 10.25 7.85\"><path d=\"M.53,3.85,3.46,6.79,6.85,3.4,9.72.53\"/></svg>";